module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-list steps-wait",
    staticStyle: {
      "width": "33.3333%"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "steps-head"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.num))])])]), _vm._v(" "), _c('div', {
    staticClass: "steps-main"
  }, [_c('div', {
    staticClass: "steps-title"
  }, [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps-tail"
  }, [_c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5dc1fc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDetails/Common/Step.vue
// module id = 803
// module chunks = 0